import { render, staticRenderFns } from "./CostTable.vue?vue&type=template&id=61c60b0f"
import script from "./CostTable.vue?vue&type=script&lang=js"
export * from "./CostTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports